import { useState } from 'react'
import { Link } from 'react-router-dom'

const C = {
  primary: '#206bc4', primaryDark: '#1a5bb5', primaryLight: '#e8f0fe',
  dark: '#0f172a', dark2: '#1e293b', dark3: '#334155',
  gray50: '#f8fafc', gray100: '#f1f5f9', gray200: '#e2e8f0', gray300: '#cbd5e1',
  gray400: '#94a3b8', gray500: '#64748b', gray600: '#475569',
  green: '#2fb344', greenLight: '#ecfdf5', purple: '#8b5cf6', amber: '#f59e0b',
  white: '#fff',
}

function BrowserFrame({ children, url = 'app.leadiox.com', dark = false }) {
  return (
    <div style={{ borderRadius: 12, overflow: 'hidden', boxShadow: '0 25px 60px rgba(0,0,0,0.18)', background: dark ? C.dark : C.white }}>
      <div style={{ background: C.gray100, padding: '8px 14px', display: 'flex', alignItems: 'center', gap: 8, borderBottom: `1px solid ${C.gray200}` }}>
        <div style={{ display: 'flex', gap: 6 }}><div style={{ width: 10, height: 10, borderRadius: '50%', background: '#ef4444' }} /><div style={{ width: 10, height: 10, borderRadius: '50%', background: '#f59e0b' }} /><div style={{ width: 10, height: 10, borderRadius: '50%', background: '#22c55e' }} /></div>
        <div style={{ flex: 1, background: C.white, borderRadius: 5, padding: '4px 12px', fontSize: 11, color: C.gray400, textAlign: 'center' }}>{url}</div>
      </div>
      {children}
    </div>
  )
}

/* ─── Software Screenshot Mockups ─── */
function MockSidebar({ active = 0, items }) {
  return (
    <div style={{ width: 160, background: C.dark, padding: '12px 0', flexShrink: 0 }}>
      <div style={{ padding: '0 12px 12px', fontWeight: 800, fontSize: 14, color: C.white, display: 'flex', alignItems: 'center', gap: 6 }}>
        <div style={{ width: 20, height: 20, borderRadius: 4, background: C.primary, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 9, color: '#fff', fontWeight: 900 }}>L</div>
        Leadiox
      </div>
      {items.map((item, i) => (
        <div key={item} style={{ padding: '5px 12px', fontSize: 10, color: i === active ? '#fff' : 'rgba(255,255,255,0.4)', background: i === active ? 'rgba(32,107,196,0.25)' : 'transparent', borderLeft: i === active ? `2px solid ${C.primary}` : '2px solid transparent' }}>{item}</div>
      ))}
    </div>
  )
}

function KpiCard({ label, value, color }) {
  return (
    <div style={{ background: C.white, borderRadius: 6, padding: '8px 10px', border: `1px solid ${C.gray200}` }}>
      <div style={{ fontSize: 8, color: C.gray500, textTransform: 'uppercase', letterSpacing: 0.3, fontWeight: 600 }}>{label}</div>
      <div style={{ fontSize: 17, fontWeight: 700, color, marginTop: 1 }}>{value}</div>
    </div>
  )
}

function ScreenDashboard() {
  return (
    <BrowserFrame>
      <div style={{ display: 'flex', minHeight: 300 }}>
        <MockSidebar active={0} items={['Dashboard', 'Leads', 'Contacts', 'Deals', 'Events', 'BEOs', 'Proposals', 'Invoices', 'Reports']} />
        <div style={{ flex: 1, background: C.gray50, padding: 14 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: C.dark, marginBottom: 10 }}>Sales Dashboard</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 6, marginBottom: 12 }}>
            <KpiCard label="Active Leads" value="24" color={C.primary} />
            <KpiCard label="Pipeline" value="$284K" color={C.green} />
            <KpiCard label="Events" value="12" color={C.purple} />
            <KpiCard label="Room Nights" value="1,240" color={C.amber} />
          </div>
          <div style={{ background: C.white, borderRadius: 6, border: `1px solid ${C.gray200}`, overflow: 'hidden' }}>
            <div style={{ padding: '7px 10px', borderBottom: `1px solid ${C.gray200}`, fontSize: 10, fontWeight: 700 }}>Recent Pipeline Activity</div>
            {[
              { name: 'Crestline Annual Conference', val: '$28,350', stage: 'Proposal', stColor: C.primary },
              { name: 'Summit Q2 Leadership Retreat', val: '$62,400', stage: 'Qualified', stColor: C.amber },
              { name: 'MSMA 2026 Medical Conference', val: '$93,600', stage: 'Discovery', stColor: C.purple },
              { name: 'Vantage Tech Offsite', val: '$9,200', stage: 'Won', stColor: C.green },
            ].map(d => (
              <div key={d.name} style={{ padding: '6px 10px', borderBottom: `1px solid ${C.gray100}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 10 }}>
                <span style={{ color: C.dark }}>{d.name}</span>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                  <span style={{ fontWeight: 600 }}>{d.val}</span>
                  <span style={{ fontSize: 8, padding: '1px 6px', borderRadius: 3, background: d.stColor + '18', color: d.stColor, fontWeight: 600 }}>{d.stage}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </BrowserFrame>
  )
}

function ScreenBEO() {
  return (
    <BrowserFrame url="app.leadiox.com/beos">
      <div style={{ display: 'flex', minHeight: 280 }}>
        <MockSidebar active={5} items={['Dashboard', 'Leads', 'Contacts', 'Deals', 'Events', 'BEOs', 'Proposals', 'Invoices', 'Reports']} />
        <div style={{ flex: 1, background: C.gray50, padding: 14 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: C.dark }}>Banquet Event Order</div>
            <div style={{ display: 'flex', gap: 6 }}>
              <span style={{ fontSize: 8, padding: '3px 8px', borderRadius: 4, background: '#2fb34418', color: C.green, fontWeight: 600 }}>Final - Rev 2</span>
            </div>
          </div>
          <div style={{ background: C.white, borderRadius: 6, border: `1px solid ${C.gray200}`, padding: 10, marginBottom: 8 }}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 6, fontSize: 10, color: C.gray600 }}>
              <div><strong>Date:</strong> April 15, 2026</div>
              <div><strong>Time:</strong> 9:00 AM - 5:00 PM</div>
              <div><strong>Room:</strong> Grand Ballroom A</div>
              <div><strong>Setup:</strong> Banquet (200 guests)</div>
              <div><strong>Contact:</strong> Linda Vasquez</div>
              <div><strong>Company:</strong> Crestline Corp</div>
            </div>
          </div>
          {[{ title: 'Room Setup', items: ['Round tables of 10 with white linen (x20)', 'Head table on riser'] }, { title: 'Food & Beverage', items: ['Continental Breakfast (x200) - $28pp', 'Plated Lunch (x200) - $48pp'] }, { title: 'AV Equipment', items: ['LCD Projector & 12ft screen - $350', 'Wireless mic (x2) - $75 ea'] }].map(s => (
            <div key={s.title} style={{ background: C.white, borderRadius: 6, border: `1px solid ${C.gray200}`, marginBottom: 6, overflow: 'hidden' }}>
              <div style={{ padding: '5px 10px', background: C.gray50, borderBottom: `1px solid ${C.gray200}`, fontSize: 10, fontWeight: 700, color: C.dark }}>{s.title}</div>
              {s.items.map(it => <div key={it} style={{ padding: '4px 10px', fontSize: 9, color: C.gray600, borderBottom: `1px solid ${C.gray100}` }}>{it}</div>)}
            </div>
          ))}
        </div>
      </div>
    </BrowserFrame>
  )
}

function ScreenInvoice() {
  return (
    <BrowserFrame url="app.leadiox.com/invoices">
      <div style={{ display: 'flex', minHeight: 260 }}>
        <MockSidebar active={7} items={['Dashboard', 'Leads', 'Contacts', 'Deals', 'Events', 'BEOs', 'Proposals', 'Invoices', 'Reports']} />
        <div style={{ flex: 1, background: C.gray50, padding: 14 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: C.dark, marginBottom: 10 }}>Invoices</div>
          <div style={{ background: C.white, borderRadius: 6, border: `1px solid ${C.gray200}`, overflow: 'hidden' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 0.7fr 0.7fr', padding: '6px 10px', borderBottom: `1px solid ${C.gray200}`, fontSize: 9, fontWeight: 700, color: C.gray500, textTransform: 'uppercase' }}>
              <div>Invoice #</div><div>Company</div><div>Amount</div><div>Status</div><div>Due</div>
            </div>
            {[
              { num: 'INV-0001', co: 'Vantage Tech', amt: '$5,025.50', st: 'Paid', stC: C.green, due: 'Mar 15' },
              { num: 'INV-0002', co: 'Belle & Grace', amt: '$16,500.00', st: 'Sent', stC: C.primary, due: 'Apr 1' },
              { num: 'INV-0003', co: 'Crestline Corp', amt: '$14,175.00', st: 'Partial', stC: C.amber, due: 'Apr 10' },
              { num: 'INV-0004', co: 'Summit Financial', amt: '$31,200.00', st: 'Draft', stC: C.gray400, due: 'May 1' },
            ].map(r => (
              <div key={r.num} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 0.7fr 0.7fr', padding: '6px 10px', borderBottom: `1px solid ${C.gray100}`, fontSize: 10, color: C.dark }}>
                <div style={{ fontWeight: 600, color: C.primary }}>{r.num}</div><div>{r.co}</div><div style={{ fontWeight: 600 }}>{r.amt}</div>
                <div><span style={{ fontSize: 8, padding: '1px 6px', borderRadius: 3, background: r.stC + '18', color: r.stC, fontWeight: 600 }}>{r.st}</span></div>
                <div style={{ color: C.gray500 }}>{r.due}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </BrowserFrame>
  )
}

function ScreenPortfolio() {
  return (
    <BrowserFrame url="app.leadiox.com/corporate">
      <div style={{ display: 'flex', minHeight: 260 }}>
        <div style={{ width: 160, background: C.dark, padding: '12px 0', flexShrink: 0 }}>
          <div style={{ padding: '0 12px 6px', fontWeight: 800, fontSize: 14, color: C.white, display: 'flex', alignItems: 'center', gap: 6 }}>
            <div style={{ width: 20, height: 20, borderRadius: 4, background: C.primary, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 9, color: '#fff', fontWeight: 900 }}>L</div>
            Leadiox
          </div>
          <div style={{ padding: '2px 12px 8px', fontSize: 8, color: C.primary, fontWeight: 600 }}>Ridgeline Hotel Group</div>
          {['Portfolio', 'Hotels', 'Regions', 'Team'].map((item, i) => (
            <div key={item} style={{ padding: '5px 12px', fontSize: 10, color: i === 0 ? '#fff' : 'rgba(255,255,255,0.4)', background: i === 0 ? 'rgba(32,107,196,0.25)' : 'transparent', borderLeft: i === 0 ? `2px solid ${C.primary}` : '2px solid transparent' }}>{item}</div>
          ))}
        </div>
        <div style={{ flex: 1, background: C.gray50, padding: 14 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: C.dark, marginBottom: 10 }}>Portfolio Overview</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 6, marginBottom: 12 }}>
            <KpiCard label="Properties" value="3" color={C.primary} />
            <KpiCard label="YTD Revenue" value="$412K" color={C.green} />
            <KpiCard label="Active Pipeline" value="$765K" color={C.purple} />
            <KpiCard label="Upcoming Events" value="18" color={C.amber} />
          </div>
          <div style={{ background: C.white, borderRadius: 6, border: `1px solid ${C.gray200}`, overflow: 'hidden' }}>
            {[
              { hotel: 'The Lexington Grand', loc: 'Nashville, TN', pipe: '$284K', ytd: '$158K', region: 'Southeast' },
              { hotel: 'The Palmetto Inn', loc: 'Charleston, SC', pipe: '$214K', ytd: '$142K', region: 'Southeast' },
              { hotel: 'The Bayshore Hotel', loc: 'Portland, ME', pipe: '$267K', ytd: '$112K', region: 'Northeast' },
            ].map(h => (
              <div key={h.hotel} style={{ padding: '8px 10px', borderBottom: `1px solid ${C.gray100}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <div style={{ fontSize: 10, fontWeight: 600, color: C.dark }}>{h.hotel}</div>
                  <div style={{ fontSize: 8, color: C.gray400 }}>{h.loc}</div>
                </div>
                <div style={{ display: 'flex', gap: 16, alignItems: 'center', fontSize: 10 }}>
                  <span style={{ fontSize: 8, padding: '1px 6px', borderRadius: 3, background: C.primaryLight, color: C.primary, fontWeight: 600 }}>{h.region}</span>
                  <div style={{ textAlign: 'right' }}><div style={{ fontSize: 8, color: C.gray400 }}>Pipeline</div><div style={{ fontWeight: 600 }}>{h.pipe}</div></div>
                  <div style={{ textAlign: 'right' }}><div style={{ fontSize: 8, color: C.gray400 }}>YTD Rev</div><div style={{ fontWeight: 600, color: C.green }}>{h.ytd}</div></div>
                  <div style={{ width: 22, height: 22, borderRadius: 4, background: C.primaryLight, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 9, color: C.primary, cursor: 'pointer' }}>→</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </BrowserFrame>
  )
}

/* ─── Feature Card ─── */
function Feature({ icon, title, desc }) {
  return (
    <div style={{ textAlign: 'center', padding: '0 8px' }}>
      <div style={{ width: 48, height: 48, borderRadius: 12, background: C.primaryLight, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px', fontSize: 22 }}>{icon}</div>
      <h3 style={{ fontSize: 16, fontWeight: 700, color: C.dark, marginBottom: 6 }}>{title}</h3>
      <p style={{ fontSize: 14, color: C.gray500, lineHeight: 1.5, margin: 0 }}>{desc}</p>
    </div>
  )
}

/* ─── FAQ Item ─── */
function FAQ({ q, a }) {
  const [open, setOpen] = useState(false)
  return (
    <div style={{ borderBottom: `1px solid ${C.gray200}`, padding: '16px 0', cursor: 'pointer' }} onClick={() => setOpen(!open)}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ fontSize: 15, fontWeight: 600, color: C.dark }}>{q}</span>
        <span style={{ fontSize: 18, color: C.gray400, transform: open ? 'rotate(45deg)' : 'none', transition: 'transform 0.2s' }}>+</span>
      </div>
      {open && <p style={{ marginTop: 10, fontSize: 14, color: C.gray500, lineHeight: 1.6 }}>{a}</p>}
    </div>
  )
}

/* ─── Main Landing Page ─── */
export default function LandingPage() {
  const LS_SINGLE = process.env.REACT_APP_LS_SINGLE_URL || 'https://leadiox.lemonsqueezy.com/buy/single-hotel'
  const LS_MC = process.env.REACT_APP_LS_MC_URL || 'https://leadiox.lemonsqueezy.com/buy/management-company'

  return (
    <div style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', Roboto, sans-serif", color: C.dark, overflowX: 'hidden' }}>

      {/* ─── NAVBAR ─── */}
      <nav style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 5%', maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div style={{ width: 32, height: 32, borderRadius: 8, background: C.primary, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 900, fontSize: 16 }}>L</div>
          <span style={{ fontWeight: 800, fontSize: 20, color: C.dark }}>Leadiox</span>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <Link to="/login" style={{ padding: '8px 20px', fontSize: 14, color: C.gray600, textDecoration: 'none', fontWeight: 500 }}>Sign In</Link>
          <Link to="/signup" style={{ padding: '8px 20px', fontSize: 14, background: C.primary, color: '#fff', borderRadius: 8, textDecoration: 'none', fontWeight: 600 }}>Get Started</Link>
        </div>
      </nav>

      {/* ─── HERO ─── */}
      <section style={{ textAlign: 'center', padding: '60px 5% 40px', maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ display: 'inline-block', padding: '4px 14px', borderRadius: 20, background: C.greenLight, color: C.green, fontSize: 13, fontWeight: 600, marginBottom: 16 }}>Built by hoteliers, for hoteliers</div>
        <h1 style={{ fontSize: 'clamp(32px, 5vw, 52px)', fontWeight: 800, lineHeight: 1.15, color: C.dark, marginBottom: 16, maxWidth: 700, marginLeft: 'auto', marginRight: 'auto' }}>
          The hotel sales CRM that doesn't need a training manual
        </h1>
        <p style={{ fontSize: 18, color: C.gray500, lineHeight: 1.6, maxWidth: 560, margin: '0 auto 28px' }}>
          Leads, proposals, BEOs, invoices, and group management in one simple platform. Get your team selling in minutes, not months.
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/signup" style={{ padding: '14px 32px', background: C.primary, color: '#fff', borderRadius: 10, textDecoration: 'none', fontWeight: 700, fontSize: 16, boxShadow: `0 4px 14px ${C.primary}40` }}>Get Started</Link>
          <a href="#pricing" style={{ padding: '14px 32px', background: C.gray100, color: C.dark, borderRadius: 10, textDecoration: 'none', fontWeight: 600, fontSize: 16 }}>View Pricing</a>
        </div>
        <p style={{ fontSize: 13, color: C.gray400, marginTop: 12 }}>14-day money-back guarantee. Cancel anytime.</p>
      </section>

      {/* ─── SCREENSHOT: DASHBOARD ─── */}
      <section style={{ padding: '0 5% 60px', maxWidth: 960, margin: '0 auto' }}>
        <ScreenDashboard />
      </section>

      {/* ─── LOGOS BAR ─── */}
      <section style={{ textAlign: 'center', padding: '30px 5%', borderTop: `1px solid ${C.gray200}`, borderBottom: `1px solid ${C.gray200}`, background: C.gray50 }}>
        <p style={{ fontSize: 13, fontWeight: 600, color: C.gray400, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 14 }}>Built for every hotel type</p>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 40, flexWrap: 'wrap', color: C.gray300, fontSize: 14, fontWeight: 600 }}>
          {['Full-Service Hotels', 'Boutique Properties', 'Conference Centers', 'Resorts', 'Select-Service', 'Management Companies'].map(t => (
            <span key={t} style={{ color: C.gray400 }}>{t}</span>
          ))}
        </div>
      </section>

      {/* ─── FEATURES GRID ─── */}
      <section style={{ padding: '60px 5%', maxWidth: 1100, margin: '0 auto' }}>
        <h2 style={{ textAlign: 'center', fontSize: 32, fontWeight: 800, color: C.dark, marginBottom: 8 }}>Everything your sales team needs</h2>
        <p style={{ textAlign: 'center', fontSize: 16, color: C.gray500, marginBottom: 40, maxWidth: 500, marginLeft: 'auto', marginRight: 'auto' }}>Stop juggling spreadsheets and disconnected tools. Leadiox brings it all together.</p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 32 }}>
          <Feature icon="📊" title="Sales Dashboard" desc="Pipeline, KPIs, and activity at a glance. Know exactly where every deal stands." />
          <Feature icon="📋" title="Lead Management" desc="Capture leads from your website, track every touchpoint, never lose a follow-up." />
          <Feature icon="📄" title="Proposals & Contracts" desc="Send branded proposals with e-signatures. Clients sign online in seconds." />
          <Feature icon="🍽️" title="BEOs & Catering" desc="Create banquet event orders with menus, setup, and AV in one click." />
          <Feature icon="💰" title="Invoicing" desc="Send invoices, track payments, and see outstanding balances instantly." />
          <Feature icon="📅" title="Events & Calendar" desc="Room blocks, function diary, and event calendar. See your entire month." />
          <Feature icon="⚡" title="Autotraces" desc="Automatic task creation for follow-ups, BEO distribution, and reminders." />
          <Feature icon="🌐" title="Guest Portal" desc="Give planners a portal to view BEOs, proposals, and event details." />
        </div>
      </section>

      {/* ─── SCREENSHOT: BEO ─── */}
      <section style={{ padding: '40px 5% 60px', background: C.gray50 }}>
        <div style={{ maxWidth: 1100, margin: '0 auto' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 48, alignItems: 'center' }}>
            <div>
              <h2 style={{ fontSize: 28, fontWeight: 800, color: C.dark, marginBottom: 12 }}>BEOs your ops team will actually use</h2>
              <p style={{ fontSize: 15, color: C.gray500, lineHeight: 1.7, marginBottom: 16 }}>
                Create banquet event orders in minutes. Organized by section - setup, food, beverage, AV, and notes. Finalize with revision tracking, then share with your ops team or the client through the guest portal.
              </p>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {['Section-based line items', 'Revision tracking with version history', 'One-click finalize and distribute', 'Client portal sharing'].map(i => (
                  <li key={i} style={{ padding: '4px 0', fontSize: 14, color: C.gray600, display: 'flex', alignItems: 'center', gap: 8 }}><span style={{ color: C.green, fontWeight: 700 }}>✓</span> {i}</li>
                ))}
              </ul>
            </div>
            <ScreenBEO />
          </div>
        </div>
      </section>

      {/* ─── SCREENSHOT: INVOICES ─── */}
      <section style={{ padding: '60px 5%' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 48, alignItems: 'center' }}>
            <ScreenInvoice />
            <div>
              <h2 style={{ fontSize: 28, fontWeight: 800, color: C.dark, marginBottom: 12 }}>Get paid faster with simple invoicing</h2>
              <p style={{ fontSize: 15, color: C.gray500, lineHeight: 1.7, marginBottom: 16 }}>
                Create invoices from any event or deal, add line items, and track payments. Auto-calculate taxes and see outstanding balances at a glance. No accountant needed.
              </p>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {['Auto-generated invoice numbers', 'Line items with tax calculation', 'Payment tracking by method', 'Status tracking (draft → sent → paid)'].map(i => (
                  <li key={i} style={{ padding: '4px 0', fontSize: 14, color: C.gray600, display: 'flex', alignItems: 'center', gap: 8 }}><span style={{ color: C.green, fontWeight: 700 }}>✓</span> {i}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* ─── SCREENSHOT: PORTFOLIO ─── */}
      <section style={{ padding: '40px 5% 60px', background: C.gray50 }}>
        <div style={{ maxWidth: 1100, margin: '0 auto' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 48, alignItems: 'center' }}>
            <div>
              <div style={{ display: 'inline-block', padding: '4px 12px', borderRadius: 16, background: C.purple + '18', color: C.purple, fontSize: 12, fontWeight: 600, marginBottom: 12 }}>Management Companies</div>
              <h2 style={{ fontSize: 28, fontWeight: 800, color: C.dark, marginBottom: 12 }}>One dashboard for your entire portfolio</h2>
              <p style={{ fontSize: 15, color: C.gray500, lineHeight: 1.7, marginBottom: 16 }}>
                VPs and regional directors see pipeline, revenue, and events across every property. Drill into any hotel's CRM with one click. Set up regions and assign your team.
              </p>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {['Portfolio-wide KPIs', 'Drill-in to any hotel CRM', 'Region-based access control', '9-role permission system'].map(i => (
                  <li key={i} style={{ padding: '4px 0', fontSize: 14, color: C.gray600, display: 'flex', alignItems: 'center', gap: 8 }}><span style={{ color: C.green, fontWeight: 700 }}>✓</span> {i}</li>
                ))}
              </ul>
            </div>
            <ScreenPortfolio />
          </div>
        </div>
      </section>

      {/* ─── MORE FEATURES ─── */}
      <section style={{ padding: '60px 5%', maxWidth: 900, margin: '0 auto' }}>
        <h2 style={{ textAlign: 'center', fontSize: 28, fontWeight: 800, color: C.dark, marginBottom: 32 }}>Plus everything else you need</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 16 }}>
          {[
            ['Web Lead Forms', 'Embed inquiry forms on your hotel website. Leads flow straight into your pipeline.'],
            ['Email Templates', 'Pre-built templates with merge fields. Send proposals, follow-ups, and BEOs in one click.'],
            ['Pace Reports', 'Compare this year vs last year by month. Track catering revenue, room nights, and lost business.'],
            ['Function Diary', 'See every meeting space booked by date. No more double-bookings.'],
            ['Space Designer', 'Manage meeting rooms with capacity by setup style.'],
            ['Group Resume', 'One-page event summary for ops, front desk, and housekeeping.'],
          ].map(([t, d]) => (
            <div key={t} style={{ padding: 16, background: C.gray50, borderRadius: 8, border: `1px solid ${C.gray200}` }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: C.dark, marginBottom: 4 }}>{t}</div>
              <div style={{ fontSize: 13, color: C.gray500, lineHeight: 1.5 }}>{d}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ─── PRICING ─── */}
      <section id="pricing" style={{ padding: '60px 5%', background: C.dark }}>
        <div style={{ maxWidth: 900, margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ fontSize: 32, fontWeight: 800, color: C.white, marginBottom: 8 }}>Simple, transparent pricing</h2>
          <p style={{ fontSize: 16, color: C.gray400, marginBottom: 40 }}>No per-user fees. No surprise charges. One price, everything included.</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 24, maxWidth: 700, margin: '0 auto' }}>
            {/* Single Hotel */}
            <div style={{ background: C.dark2, borderRadius: 16, padding: 32, border: `1px solid ${C.dark3}`, textAlign: 'left' }}>
              <div style={{ fontSize: 14, fontWeight: 600, color: C.primary, marginBottom: 6 }}>Single Hotel</div>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: 4, marginBottom: 4 }}>
                <span style={{ fontSize: 42, fontWeight: 800, color: C.white }}>$99</span>
                <span style={{ fontSize: 15, color: C.gray400 }}>/month</span>
              </div>
              <p style={{ fontSize: 13, color: C.gray400, marginBottom: 20, lineHeight: 1.5 }}>Full CRM with unlimited users. Everything your hotel needs to sell smarter.</p>
              <a href={LS_SINGLE} style={{ display: 'block', textAlign: 'center', padding: '12px 24px', background: C.primary, color: '#fff', borderRadius: 8, textDecoration: 'none', fontWeight: 600, fontSize: 15, marginBottom: 20 }}>Get Started</a>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {['Unlimited users', 'Leads, deals, & pipeline', 'Proposals with e-sign', 'BEOs & catering', 'Invoicing & payments', 'Web lead forms', 'Email templates', 'Autotraces', 'Guest portal', 'Reports & pace'].map(i => (
                  <li key={i} style={{ padding: '4px 0', fontSize: 13, color: C.gray300, display: 'flex', gap: 8 }}><span style={{ color: C.green }}>✓</span>{i}</li>
                ))}
              </ul>
            </div>
            {/* Management Company */}
            <div style={{ background: C.dark2, borderRadius: 16, padding: 32, border: `2px solid ${C.primary}`, textAlign: 'left', position: 'relative' }}>
              <div style={{ position: 'absolute', top: -12, right: 20, padding: '4px 12px', borderRadius: 12, background: C.primary, color: '#fff', fontSize: 11, fontWeight: 700 }}>BEST VALUE</div>
              <div style={{ fontSize: 14, fontWeight: 600, color: C.primary, marginBottom: 6 }}>Management Company</div>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: 4, marginBottom: 4 }}>
                <span style={{ fontSize: 42, fontWeight: 800, color: C.white }}>$799</span>
                <span style={{ fontSize: 15, color: C.gray400 }}>/mo + $79/hotel</span>
              </div>
              <p style={{ fontSize: 13, color: C.gray400, marginBottom: 20, lineHeight: 1.5 }}>Corporate dashboard with drill-in access to every property in your portfolio.</p>
              <a href={LS_MC} style={{ display: 'block', textAlign: 'center', padding: '12px 24px', background: C.primary, color: '#fff', borderRadius: 8, textDecoration: 'none', fontWeight: 600, fontSize: 15, marginBottom: 20 }}>Get Started</a>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {['Everything in Single Hotel', 'Portfolio dashboard', 'Region management', 'VP & Regional Director roles', 'Cross-property reporting', 'Drill-in to any hotel CRM', 'Corporate team management', 'Dedicated onboarding'].map(i => (
                  <li key={i} style={{ padding: '4px 0', fontSize: 13, color: C.gray300, display: 'flex', gap: 8 }}><span style={{ color: C.green }}>✓</span>{i}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* ─── COMPARISON ─── */}
      <section style={{ padding: '60px 5%', maxWidth: 800, margin: '0 auto' }}>
        <h2 style={{ textAlign: 'center', fontSize: 28, fontWeight: 800, color: C.dark, marginBottom: 8 }}>Why switch to Leadiox?</h2>
        <p style={{ textAlign: 'center', fontSize: 15, color: C.gray500, marginBottom: 32 }}>We built Leadiox because hotel sales teams deserved better.</p>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 }}>
          <div style={{ padding: 24, background: '#fef2f2', borderRadius: 12, border: '1px solid #fecaca' }}>
            <div style={{ fontSize: 16, fontWeight: 700, color: '#dc2626', marginBottom: 12 }}>The old way</div>
            {['Spreadsheets for lead tracking', 'Email threads for proposals', 'Manual BEOs in Word docs', 'No pipeline visibility', 'Separate tools for everything', 'Weeks of training'].map(i => (
              <div key={i} style={{ padding: '4px 0', fontSize: 13, color: '#991b1b', display: 'flex', gap: 8 }}><span>✕</span>{i}</div>
            ))}
          </div>
          <div style={{ padding: 24, background: C.greenLight, borderRadius: 12, border: '1px solid #bbf7d0' }}>
            <div style={{ fontSize: 16, fontWeight: 700, color: C.green, marginBottom: 12 }}>With Leadiox</div>
            {['One place for all leads & deals', 'Send proposals in 2 minutes', 'BEOs with auto line items', 'Real-time pipeline dashboard', 'Everything connected', 'Up and running in 10 minutes'].map(i => (
              <div key={i} style={{ padding: '4px 0', fontSize: 13, color: '#166534', display: 'flex', gap: 8 }}><span style={{ color: C.green }}>✓</span>{i}</div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── FAQ ─── */}
      <section style={{ padding: '40px 5% 60px', background: C.gray50 }}>
        <div style={{ maxWidth: 700, margin: '0 auto' }}>
          <h2 style={{ textAlign: 'center', fontSize: 28, fontWeight: 800, color: C.dark, marginBottom: 32 }}>Frequently Asked Questions</h2>
          <FAQ q="What is the money-back guarantee?" a="If you're not satisfied within the first 14 days after signing up, we'll refund your payment in full. No questions asked." />
          <FAQ q="How many users can I add?" a="Unlimited. Every plan includes unlimited users at no extra cost. Add your entire sales team, front desk, and operations." />
          <FAQ q="Can I import my existing data?" a="Yes. You can import leads, contacts, and events from CSV files or we can help you migrate from your current system." />
          <FAQ q="Is there a contract or commitment?" a="No long-term contracts. Leadiox is month-to-month. Cancel anytime and keep access through the end of your billing cycle." />
          <FAQ q="Do you integrate with our PMS?" a="We're actively building PMS integrations starting with Cloudbeds and Mews. Contact us for your specific PMS." />
          <FAQ q="Is my data secure?" a="Absolutely. All data is encrypted in transit and at rest. We use industry-standard security practices and never share your data." />
        </div>
      </section>

      {/* ─── FINAL CTA ─── */}
      <section style={{ textAlign: 'center', padding: '60px 5%', background: C.primary }}>
        <h2 style={{ fontSize: 32, fontWeight: 800, color: '#fff', marginBottom: 12 }}>Ready to modernize your hotel sales?</h2>
        <p style={{ fontSize: 16, color: 'rgba(255,255,255,0.8)', marginBottom: 24, maxWidth: 460, margin: '0 auto 24px' }}>Join hotels that are closing more business with less effort. 14-day money-back guarantee.</p>
        <Link to="/signup" style={{ display: 'inline-block', padding: '14px 36px', background: '#fff', color: C.primary, borderRadius: 10, textDecoration: 'none', fontWeight: 700, fontSize: 16, boxShadow: '0 4px 14px rgba(0,0,0,0.15)' }}>Get Started</Link>
      </section>

      {/* ─── FOOTER ─── */}
      <footer style={{ padding: '32px 5%', background: C.dark, color: C.gray400, fontSize: 13 }}>
        <div style={{ maxWidth: 1100, margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <div style={{ width: 24, height: 24, borderRadius: 6, background: C.primary, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 900, fontSize: 12 }}>L</div>
            <span style={{ fontWeight: 700, color: C.gray300 }}>Leadiox</span>
            <span style={{ marginLeft: 8 }}>&copy; {new Date().getFullYear()} Delvios LLC. All rights reserved.</span>
          </div>
          <div style={{ display: 'flex', gap: 20 }}>
            <Link to="/terms" style={{ color: C.gray400, textDecoration: 'none' }}>Terms of Service</Link>
            <Link to="/privacy" style={{ color: C.gray400, textDecoration: 'none' }}>Privacy Policy</Link>
            <a href="mailto:support@leadiox.com" style={{ color: C.gray400, textDecoration: 'none' }}>Contact</a>
          </div>
        </div>
      </footer>
    </div>
  )
}
